<template>
<div>
  <div class="setting">
    <div class="setting-item" style="text-align:center;">
      <p style="font-size: 150%;">フォントサービス購入完了</p>
      <div style="display: inline-block;min-width: 100%;text-align:center;">
        <p style="font-size: 140%;"> 
          購入金額：220円（税込）
        </p>
      </div>
      <div style="display: inline-block;min-width: 100%;text-align:center;">
        購入が完了されました。続けてフォントサービスをご利用ください。
      </div>
        <ul style="text-align: left; font-size: 0.7rem; margin-left: 0;">
            <li>※フォントの切り替え方法については<a href="/fontservicehelp" target="_blank">こちら</a>をご確認ください。</li>
        </ul>
    </div>
  </div>
</div>
</template>
<script>
export default {
  data: function () {
    return {
      clearLocalStorageConfirmVisible: false,
      currentFormat: {},
      formatid: '',
      previewHtml: '',
      permissionType: 1,
      isFontpaymentSended:false,
      isMedlySended:false,
      isAdtopSended:false,
      isJigenSended:false,
      fullscreenLoading:false,
      username:'',
      paypayurl:'',
      merchant_payment_id:'',
      isAgree:false
    }
  },
  methods: {
    goJobdetail: function () {
    },
    complatePayPay: function (merchant_payment_id) {

      const app = this
      const formData = new FormData()
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('merchant_payment_id', merchant_payment_id)
      formData.append('app_flag', this.$site.appFlag)
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP': 'PC')
      formData.append('site_flag', 'r')
      formData.append('version', '3')
      this.$axios
        .post(this.$varuna.endPoints.paypayComplateFont, formData, {timeout: 60000})
        .then(async function (response) {
          if (response['data']['status'] == 'success') {
          // if (response['data']['data']['status'] == 'COMPLETED') {
            app.$message({
              duration: 0,
              message: '支払確認ができました。購入処理を完了します',
              type: 'success'
            })
            app.fullscreenLoading = false
          } else {
            app.$message({
              duration: 0,
              message: '取得失敗しました。エラーコード：EQ1001',
              type: 'error'
            })
          }
        })
        .catch(function (error) {
          console.error(error)
          app.$message({
            message: '取得失敗しました。',
            type: 'error'
          })
        }).finally(function () {
          // app.goCardTo('payment')
          app.fullscreenLoading = false
        })
    }
  },
  created: function() {
    if (this.$route.query.merchant_payment_id) {
      this.fullscreenLoading = true
      this.complatePayPay(this.$route.query.merchant_payment_id)
    }
    
  }
}
</script>
